import { ProcedureParams } from '../../../../../shared/types/systemConfiguration/procedureParams';

export const initialValues: ProcedureParams = {
    name: '',
    active: true,
};
